import * as Yup from "yup";

const AddLibraryVideoValidator = Yup.object({
  name: Yup.string()
    .required("Name is required")
    .min(3, "Name must be at least 3 characters long")
    .max(100, "Name must be less than 100 characters long"),
  description: Yup.string()
    .required("Description is required")
    .min(3, "Description must be at least 3 characters long")
    .max(250, "Description must be less than 250 characters long"),
  status: Yup.string()
    .required("Status is required")
    .oneOf(["1", "2"], "Invalid status"),
  video_name: Yup.string()
    .required("Video name is required")
    .test(
      "is-video",
      "File must be a valid video file",
      function(value ) {
        if(!value || value.includes('http')) return true;
        
        const validExtensions = ['mp4', 'mkv', 'avi', 'mov', 'webm'];
        // Check if the file has a valid extension
        const isValid = validExtensions.some(extension => value.toLowerCase().endsWith(extension));
        return isValid;
      },
    ),
  library_category_id: Yup.string()
    .required("Parent is required")
});

export default AddLibraryVideoValidator;